module.exports = __webpack_public_path__ + "static/media/ic_attetion.b4a9fbd3.svg";